// extracted by mini-css-extract-plugin
module.exports = {"card":"card--1ozf1","card_title":"card_title--31ZA_","active":"active--2mue0"};